import styles from './OrderAmountError.module.scss';
import { OrderAmountErrorProps } from './types';
import { useOrderAmountError } from './useOrderAmountError';

export type { ActiveLimitType, OrderAmountErrorProps } from './types';
export { useOrderAmountError } from './useOrderAmountError';
export { getOrderAmountErrorMessage } from './getOrderAmountErrorMessage';
export { resolveWorkerLimitError } from './resolveWorkerLimitError';

type OrderAmountErrorMessageProps = {
  message: string | null;
  className?: string;
};

export const OrderAmountErrorMessage = ({
  message,
  className,
}: OrderAmountErrorMessageProps) => (
  <p className={className ?? styles.errorPlaceholder}>{message}</p>
);

export const OrderAmountError = (props: OrderAmountErrorProps) => {
  const { message } = useOrderAmountError(props);

  return <OrderAmountErrorMessage message={message} className={props.className} />;
};
